export default __webpack_public_path__ + "media/images/logo-pds-white-cb328ea98064e5a7c234760fa26d4750.svg";